/**
  * 桑基分析-->树图
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let option = {
    tooltip: {
      trigger: "item",
      triggerOn: "mousemove",
      formatter: function (params) {
        let data = params.treeAncestors.filter((v) => {
          return v.name != "";
        });
        let result = "";
        data.map((v) => {
          result += `<div style="display: flex;"><p>${v.name}</p><span style="display: inline-block;font-weight: bold;margin-left: 5px;">${dealBigNum(v.value)}</span>kw·h</div>`;
        });
        return result;
      },
    },
    series: {
      type: "tree",
      data: paramObj,
      top: "1%",
      left: "10%",
      bottom: "1%",
      right: "20%",
      symbolSize: 7,
      label: {
        position: "left",
        verticalAlign: "middle",
        align: "right",
        fontSize: 12,
        lineHeight: 24,
        formatter: function (params) {
          if (params.data.level == 0) {
            return "{a|" + params.name + "}";
          } else if (params.data.level == 1) {
            return "{b|" + params.name + "}";
          } else if (params.data.level == 2) {
            return "{c|" + params.name + "}";
          } else if (params.data.level == 3) {
            return "{d|" + params.name + "}";
          } else {
            return "{e|" + params.name + "}";
          }
        },
        rich: {
          a: {
            padding: 10,
            borderRadius: 3,
            color: "#fff",
            backgroundColor: "#7ACDCC",
          },
          b: {
            padding: 8,
            borderRadius: 3,
            color: "#fff",
            backgroundColor: "#86B7EB",
          },
          c: {
            padding: 6,
            borderRadius: 3,
            color: "#fff",
            backgroundColor: "#A6CEA6",
          },
          d: {
            padding: 6,
            borderRadius: 3,
            color: "#fff",
            backgroundColor: "#B4B4F7",
          },
          e: {
            padding: 6,
            borderRadius: 3,
            color: "#fff",
            backgroundColor: "#D8C7A4",
          },
        },
      },
      lineStyle: {
        color: "#DCEAF0",
        width: 4,
      },
      leaves: {
        label: {
          position: "right",
          verticalAlign: "middle",
          align: "left",
        },
      },
      emphasis: {
        focus: "relative",
        lineStyle: {
          color: "#DCEAF0",
        },
      },
    },
  };

  return option
  
}